function update_url(resp) {
  if (window.history && 'pushState' in window.history) {
    const url = resp.data.data.url;
    window.history.pushState(null, '', url);
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical !== null) {
      canonical.href = url;
    }
  }
}
function groupBy(objectArray, property, value) {
  return objectArray.reduce(function (acc, obj) {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj[value]);
    return acc;
  }, {});
}
function getFormData(filter_form) {
  let o = null;
  let formData = new FormData(filter_form);
  let object = [];
  formData.forEach(function (value, key) {
    o = {
      name: key,
      value: value,
    };
    object.push(o);
  });
  const pieces = groupBy(object, 'name', 'value');
  formData = new FormData();
  for (const piece in pieces) {
    if (pieces.hasOwnProperty(piece)) {
      formData.append(piece, pieces[piece].join('|'));
    }
  }
  return formData;
}
function oiFilterDisableForm(oi_filter_form) {
  if (oi_filter_form) {
    let i;
    // Disable all form inputs
    for (i = 0; i < oi_filter_form.elements.length; i++) {
      oi_filter_form.elements[i].setAttribute('disabled', 'disabled');
    }
    // Disable all elements with class of "oi-disable-while-pending"
    const to_disable = document.getElementsByClassName('oi-disable-while-pending');
    for (i = 0; i < to_disable.length; i++) {
      to_disable[i].setAttribute('disabled', 'disabled');
    }
    // Reduce the opacity of all elements with class of "model-filters"
    // ?? Can we just do this for all elements inside the form ??
    const model_filters = document.getElementsByClassName('model-filters');
    for (i = 0; i < model_filters.length; i++) {
      model_filters[i].style.opacity = '0.6';
    }
    // ?? What about an overlay and spinner ??
  }
}
function oiFilterEnableForm(oi_filter_form) {
  if (oi_filter_form) {
    setTimeout(function () {
      let i;
      // Remove the disabled attribute and value from inputs.
      for (i = 0; i < oi_filter_form.elements.length; i++) {
        oi_filter_form.elements[i].disabled = false;
        oi_filter_form.elements[i].removeAttribute('disabled');
      }
      // Remove disabled from all elements with class of "oi-disable-while-pending"
      const to_disable = document.getElementsByClassName('oi-disable-while-pending');
      for (i = 0; i < to_disable.length; i++) {
        to_disable[i].disabled = false;
        to_disable[i].removeAttribute('disabled');
      }
      // Reset the opacity of all elements with class of "model-filters"
      const model_filters = document.getElementsByClassName('model-filters');
      for (i = 0; i < model_filters.length; i++) {
        model_filters[i].style.opacity = '1';
      }
    }, 500);
  }
}
function oiFilterAjaxBeforesend(oi_filter_form, from_infinite) {
  if (from_infinite === undefined || from_infinite === false) {
    oiFilterDisableForm(oi_filter_form);
  }
}
function oiFilterGetResults(oi_filter_form, results) {
  const ftype = oi_filter_form.dataset.filterType;
  const url = `/xhr/filter/${ftype}/`;
  const formData = getFormData(oi_filter_form);
  oi.axios({
    method: 'post',
    url: url,
    data: formData,
    headers: {
      'Content-Type': 'application/json',
    },
    transformRequest: [
      function (data, headers) {
        // We're not really transforming the request, but this function runs
        // before the ajax posts.
        oiFilterAjaxBeforesend(oi_filter_form, false);
        // We let the data pass-through unchanged.
        return data;
      },
    ],
  })
    .then(function (resp) {
      if (resp.data.data.result_list) {
        if (resp.data.options) {
          const options = resp.data.options;
          for (const id in options) {
            document.getElementById(option).innerHTML = options[option];
          }
        }
        if (resp.data.paginator && resp.data.paginator !== '') {
          const pageinput = oi_filter_form.querySelector('input[name="page"]');
          pageinput.value = resp.data.paginator.next;
        }
        results.innerHTML = resp.data.data.result_list;
        const oi_filter_amount = document.getElementById('oi-filter-amount');
        if (oi_filter_amount !== null && resp.data.data.amount) {
          oi_filter_amount.innerHTML = resp.data.data.amount;
        }
        if (resp.data.result_list_lot) {
          const results_lot = document.getElementById('oi-filter-results-lot');
          results_lot.innerHTML = resp.data.result_list;
        }
        if (resp.data.result_list_land) {
          const results_land = document.getElementById('oi-filter-results-land');
          results_land.innerHTML = resp.data.result_list;
        }
        if (resp.data.map_items && resp.data.map_items !== '') {
          const map_items = document.querySelector('.oi-all-map-items');
          map_items.innerHTML = resp.data.map_items;
        }
        update_url(resp);
        if (window.afterResultsSuccess !== undefined) {
          window.afterResultsSuccess();
        }
        if (oi.loaded.map['oi-map']) {
          oi.loaded.map['oi-map'].set_markers(ftype);
          oi.loaded.map['oi-map'].fit();
        }
      }
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status == 400) {
          let msg = '';
          const errors = error.response.data.errors;
          for (let err in errors) {
            let x = errors[err];
            msg = `${x.code} - ${x.description}\n`;
          }
          oiFilterEnableForm(oi_filter_form);
        } else if (error.response.status == 302) {
          // Redirecting
          window.location.href = error.response.data.data.redirect;
        }
      } else if (error.request) {
        console.error(error.request);
      } else {
        console.error(error.message);
      }
    })
    .then(function () {
      const name_input = oi_filter_form.querySelector('input[name="m"]');
      if (name_input !== null) {
        name_input.value = '0';
      }
      oiFilterEnableForm(oi_filter_form);
    });
}
window.addEventListener('load', () => {
  const oi_filter_form = document.getElementById('oi-filter-form');
  if (oi_filter_form) {
    const oi_filter_clickables = oi_filter_form.querySelectorAll('.oi-filter-click');
    const oi_filter_changables = oi_filter_form.querySelectorAll('.oi-filter-change');
    oi_filter_clickables.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        e.preventDefault();
        oiFilterGetResults(oi_filter_form, oi_filter_results);
      });
    });
    oi_filter_changables.forEach((elem) => {
      elem.addEventListener('change', (e) => {
        e.preventDefault();
        oiFilterGetResults(oi_filter_form, oi_filter_results);
      });
    });
    const oi_filter_reset = oi_filter_form.querySelectorAll('.oi-filter-reset');
    const oi_filter_results = document.getElementById('oi-filter-results');
    if (oi_filter_reset !== null && oi_filter_results !== null) {
      oi_filter_reset.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          let i;
          e.preventDefault();
          const to_clear = document.getElementsByClassName('oi-clear-on-reset');
          if (to_clear) {
            for (i = 0; i < to_clear.length; i++) {
              if (to_clear[i].type == 'select-one') {
                to_clear[i].selectedIndex = 0;
              }
              if (to_clear[i].id == 'boyl-input') {
                to_clear[i].value = false;
              }
              if (to_clear[i].type == 'checkbox') {
                to_clear[i].checked = false;
              }
            }
          }
          const buttons_to_reset = document.getElementsByClassName('filter-button-on');
          if (buttons_to_reset) {
            for (i = 0; i < buttons_to_reset.length; i++) {
              buttons_to_reset[i].classList.remove('filter-button-on');
            }
          }
          oiFilterGetResults(oi_filter_form, oi_filter_results);
        });
      });
    }
  }
  // This function OVERWRITES the default onpopstate behavior, which is perhaps desireable.
  // If overwriting is not necessary, the alternate function below is more desirable, as
  // it ADDS functiontionality.
  // window.onpopstate = function (event) {
  //     location.reload();
  // }
  let pathName = document.location.pathname;
  window.addEventListener('popstate', (e) => {
    if (pathName === e.target.location.pathname) {
      return false;
    }
    location.reload();
  });
});
